import { Badge } from "@/components/ui/badge";
import { TID } from "@/constants/testIds";
import { CLASS_COLOURS, STATUS_COLOURS } from "./_shared";

export function IncidentsTab({ incidents, loading, onSelect }) {
  if (loading) return <div className="h-40 rounded-lg bg-white border border-slate-200 shimmer" />;
  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="grid gap-2 px-4 py-2.5 text-[11px] uppercase tracking-wider text-white bg-gbe" style={{ gridTemplateColumns: "0.9fr 0.9fr 0.7fr 1.2fr 2fr 0.9fr 0.8fr" }}>
        <div>Ref</div>
        <div>Date</div>
        <div>BU</div>
        <div>Category</div>
        <div>Location / Employee</div>
        <div>Classification</div>
        <div>Status</div>
      </div>
      <div className="divide-y divide-slate-100">
        {incidents.length === 0 && <div className="p-10 text-center text-sm text-slate-500">No incidents recorded.</div>}
        {incidents.map((inc) => (
          <div
            key={inc.id}
            data-testid={TID.hseqIncidentRow(inc.id)}
            onClick={() => onSelect(inc)}
            className="grid gap-2 px-4 py-3 text-sm items-center hover:bg-slate-50 cursor-pointer"
            style={{ gridTemplateColumns: "0.9fr 0.9fr 0.7fr 1.2fr 2fr 0.9fr 0.8fr" }}
          >
            <div className="font-mono text-xs text-slate-500">{inc.ref_number}</div>
            <div className="text-slate-700">{inc.date_of_incident}</div>
            <div className="font-mono text-xs text-slate-600">{inc.business_unit_code || "—"}</div>
            <div className="text-slate-800">{inc.incident_category}</div>
            <div className="min-w-0">
              <div className="text-slate-900 truncate">{inc.incident_location}</div>
              <div className="text-xs text-slate-500 truncate">{inc.employee_name || "—"}</div>
            </div>
            <div>
              <Badge className="text-xs" style={{ background: `${CLASS_COLOURS[inc.classification] || "#94A3B8"}22`, color: CLASS_COLOURS[inc.classification] || "#475569" }}>
                {inc.classification}
              </Badge>
            </div>
            <div><Badge className={`text-xs ${STATUS_COLOURS[inc.status] || "bg-slate-100"}`}>{inc.status?.replace("_", " ")}</Badge></div>
          </div>
        ))}
      </div>
    </div>
  );
}
